import React, {useContext, useState} from 'react';
import styled from 'styled-components';
import {OverlayContext} from '../contexts/OverlayContext';

import {OzButton, OzCard, OzRow, OzCol, OzTable, OzCheckbox, OzTooltip, OzProjectTag, BITTERSWEET} from '@ozwol/webui';

import WebhooksService from '../services/WebhooksService';

import ModalWebhook4 from './ModalWebhook4';
import WebhookWizard from './WebhookWizard';

import CardHeaderTitle from '../components/CardHeaderTitle';
import ErrorMessage from '../components/ErrorMessage';

import {formatError} from '../helpers';

const Container = styled.div`
  width: 450px;
`;
const TableWrapper = styled.div`
  & table tr td{
    white-space: nowrap;
  }
  & table tr td:nth-child(2),
  & table tr td:nth-child(3),
  & table tr td:nth-child(5){
    word-break: break-all;
    white-space: unset;
  }
`;
const ProjectsWrapper = styled.div`
  width: 100%;
  max-height: ${props => props.show ? "300px" : "0px"};
  overflow-x: hidden;
  overflow-y: auto;
  transition: all 0.25s ease-in-out;

`;

const ModalWebhook3 = ({item, projects, onSuccess}) => {
  const {replaceOverlay, removeOverlay} = useContext(OverlayContext);
	const [currentItem, setCurrentItem] = useState(item);
	const [errorMessage, setErrorMessage] = useState(false);

  return (
    <Container>

      <OzCard
        headerLeft={
          <CardHeaderTitle title={"Projects"} />
        }
        headerSeparator={true}
        footerLeft={<OzButton variant={"chetwodeblue-o"} onClick={() => removeOverlay("webhook")}>Cancel</OzButton>}
        footerRight={
          <OzButton 
            variant={"chetwodeblue-o"} 
						disabled={!currentItem || !currentItem.projectsUuid || currentItem.projectsUuid.length === 0}
            onClick={() => {
							if(currentItem.uuid){
								WebhooksService.update(currentItem.uuid, currentItem).then((response) => {
									replaceOverlay({
										reference: "webhook",
										content: <ModalWebhook4
											item={response} 
											onSuccess={onSuccess}
										/>,
										isCloseable: false
									}, "webhook");
								}).catch((error) => {
									setErrorMessage(formatError(error));
								});
							}else{
								WebhooksService.create(currentItem).then((response) => {
									replaceOverlay({
										reference: "webhook",
										content: <ModalWebhook4
											item={response} 
											onSuccess={onSuccess}
										/>,
										isCloseable: false
									}, "webhook");
								}).catch((error) => {
									setErrorMessage(formatError(error));
								});
							}							
						}}
          >Save</OzButton>}
      >
        
        {/* xxx
				
				<br/><br/> */}
				
				<OzRow>
					<OzCol widthmd="12">
						<OzCheckbox
							toggle={true}
							label={<>All projects <OzTooltip>Enable webhook event notifications to all present and future projects of the account. To limit the access to specified projects, deselect the radio button and select the single projects of interest from the list below.</OzTooltip></>}
							selected={currentItem && currentItem.projectsUuid && currentItem.projectsUuid.length > 0 && currentItem.projectsUuid[0] === "*" ? true : false}
							onChange={(val) => {
								let tempItem = {...currentItem};    
								if(val){
									tempItem.projectsUuid = ["*"];
								}else{
									tempItem.projectsUuid = [];
								}
								setCurrentItem(tempItem);
							}}
						/>
					</OzCol>
					<br/><br/><br/>
					
					<OzCol widthmd="12">
						<ProjectsWrapper show={!currentItem || !currentItem.projectsUuid || (currentItem.projectsUuid.length === 0 || (currentItem.projectsUuid.length > 0 && currentItem.projectsUuid[0] !== "*"))}>
							<TableWrapper>
								<OzTable
									selectable={true}
									selected={currentItem && currentItem.projectsUuid ? currentItem && currentItem.projectsUuid : []}
									onSelect={(ids) => {
										
										let tempItem = {...currentItem};
										  
									
										if(!tempItem.projectsUuid){
											tempItem.projectsUuid = [];
										}

										let tempSelected = [...tempItem.projectsUuid];
										
										ids.forEach(id => {
											if(!tempItem.projectsUuid.includes(id)){
												tempSelected.push(id);
											}else{
												tempSelected = tempSelected.filter(e => e !== id);
											}                    
										});
										tempItem.projectsUuid = [...tempSelected];
										setCurrentItem(tempItem);
									}}
									values={
										projects.map(item => ({
											id: item.uuid,
											style: !item.active ? {
												background: BITTERSWEET+"33",
												backgroundHover: BITTERSWEET+"55"
											} : {},
											values: [
												<OzProjectTag
													direction="horizontal"
													key={item.uuid}
													name={item.name}
													uuid={item.uuid}
													color={item.color}
												/>
											]
										}))
									}
								/>
							</TableWrapper>
						</ProjectsWrapper>
					</OzCol>
					
				</OzRow>

        <WebhookWizard step={3} />

        <ErrorMessage noMargin>
          {errorMessage}
        </ErrorMessage>
				
      </OzCard>

    </Container>
  );

}

export default ModalWebhook3;
